// Comprehensive structured health data
export const HEALTH_CATEGORIES = {
  ALLERGIES: {
    name: 'Alerjiler',
    nameEn: 'Allergies',
    icon: '🤧',
    color: 'red',
    subcategories: {
      FOOD: {
        name: 'Gıda Alerjileri',
        nameEn: 'Food Allergies',
        items: [
          { name: 'Fıstık', nameEn: 'Peanuts', severity: 'high' },
          { name: 'Badem', nameEn: 'Tree Nuts', severity: 'high' },
          { name: 'Süt Ürünleri', nameEn: 'Dairy', severity: 'medium' },
          { name: 'Yumurta', nameEn: 'Eggs', severity: 'medium' },
          { name: 'Buğday/Gluten', nameEn: 'Wheat/Gluten', severity: 'medium' },
          { name: 'Soya', nameEn: 'Soy', severity: 'medium' },
          { name: 'Balık', nameEn: 'Fish', severity: 'high' },
          { name: 'Kabuklu Deniz Ürünleri', nameEn: 'Shellfish', severity: 'high' },
          { name: 'Susam', nameEn: 'Sesame', severity: 'medium' },
          { name: 'Çilek', nameEn: 'Strawberries', severity: 'low' },
          { name: 'Kiwi', nameEn: 'Kiwi', severity: 'low' },
          { name: 'Çikolata', nameEn: 'Chocolate', severity: 'low' }
        ]
      },
      ENVIRONMENTAL: {
        name: 'Çevresel Alerjiler',
        nameEn: 'Environmental Allergies',
        items: [
          { name: 'Polen (Çimen)', nameEn: 'Grass Pollen', severity: 'medium' },
          { name: 'Polen (Ağaç)', nameEn: 'Tree Pollen', severity: 'medium' },
          { name: 'Polen (Yabani Ot)', nameEn: 'Weed Pollen', severity: 'medium' },
          { name: 'Ev Tozu Akarı', nameEn: 'Dust Mites', severity: 'medium' },
          { name: 'Hayvan Tüyü (Kedi)', nameEn: 'Cat Dander', severity: 'medium' },
          { name: 'Hayvan Tüyü (Köpek)', nameEn: 'Dog Dander', severity: 'medium' },
          { name: 'Küf', nameEn: 'Mold', severity: 'medium' },
          { name: 'Hamamböceği', nameEn: 'Cockroach', severity: 'low' },
          { name: 'Latex', nameEn: 'Latex', severity: 'high' },
          { name: 'Parfüm/Kokular', nameEn: 'Perfumes/Fragrances', severity: 'low' }
        ]
      },
      MEDICATION: {
        name: 'İlaç Alerjileri',
        nameEn: 'Drug Allergies',
        items: [
          { name: 'Penisilin', nameEn: 'Penicillin', severity: 'high' },
          { name: 'Aspirin', nameEn: 'Aspirin', severity: 'medium' },
          { name: 'İbuprofen', nameEn: 'Ibuprofen', severity: 'medium' },
          { name: 'Antibiyotikler (Genel)', nameEn: 'Antibiotics (General)', severity: 'high' },
          { name: 'Sulfa İlaçları', nameEn: 'Sulfa Drugs', severity: 'high' },
          { name: 'Kodein', nameEn: 'Codeine', severity: 'medium' },
          { name: 'Morfin', nameEn: 'Morphine', severity: 'high' },
          { name: 'Anestezi', nameEn: 'Anesthesia', severity: 'high' },
          { name: 'Kontrast Madde', nameEn: 'Contrast Dye', severity: 'high' }
        ]
      },
      INSECT: {
        name: 'Böcek Sokması',
        nameEn: 'Insect Stings',
        items: [
          { name: 'Arı Sokması', nameEn: 'Bee Stings', severity: 'high' },
          { name: 'Eşek Arısı', nameEn: 'Wasp Stings', severity: 'high' },
          { name: 'Karınca Sokması', nameEn: 'Ant Stings', severity: 'medium' },
          { name: 'Sivrisinek', nameEn: 'Mosquito Bites', severity: 'low' }
        ]
      }
    }
  },
  CONDITIONS: {
    name: 'Sağlık Durumları',
    nameEn: 'Medical Conditions',
    icon: '🏥',
    color: 'blue',
    subcategories: {
      CHRONIC: {
        name: 'Kronik Hastalıklar',
        nameEn: 'Chronic Diseases',
        items: [
          { name: 'Diyabet Tip 1', nameEn: 'Type 1 Diabetes', severity: 'high' },
          { name: 'Diyabet Tip 2', nameEn: 'Type 2 Diabetes', severity: 'high' },
          { name: 'Hipertansiyon', nameEn: 'Hypertension', severity: 'medium' },
          { name: 'Astım', nameEn: 'Asthma', severity: 'medium' },
          { name: 'KOAH', nameEn: 'COPD', severity: 'high' },
          { name: 'Kalp Hastalığı', nameEn: 'Heart Disease', severity: 'high' },
          { name: 'Böbrek Hastalığı', nameEn: 'Kidney Disease', severity: 'high' },
          { name: 'Karaciğer Hastalığı', nameEn: 'Liver Disease', severity: 'high' },
          { name: 'Tiroid Hastalığı', nameEn: 'Thyroid Disease', severity: 'medium' },
          { name: 'Artrit', nameEn: 'Arthritis', severity: 'medium' },
          { name: 'Osteoporoz', nameEn: 'Osteoporosis', severity: 'medium' },
          { name: 'Epilepsi', nameEn: 'Epilepsy', severity: 'high' },
          { name: 'Migren', nameEn: 'Migraine', severity: 'medium' }
        ]
      },
      MENTAL_HEALTH: {
        name: 'Ruh Sağlığı',
        nameEn: 'Mental Health',
        items: [
          { name: 'Depresyon', nameEn: 'Depression', severity: 'medium' },
          { name: 'Anksiyete Bozukluğu', nameEn: 'Anxiety Disorder', severity: 'medium' },
          { name: 'Bipolar Bozukluk', nameEn: 'Bipolar Disorder', severity: 'high' },
          { name: 'OKB', nameEn: 'OCD', severity: 'medium' },
          { name: 'PTSD', nameEn: 'PTSD', severity: 'medium' },
          { name: 'Dikkat Eksikliği', nameEn: 'ADHD', severity: 'medium' },
          { name: 'Panik Bozukluk', nameEn: 'Panic Disorder', severity: 'medium' }
        ]
      },
      AUTOIMMUNE: {
        name: 'Otoimmün Hastalıklar',
        nameEn: 'Autoimmune Diseases',
        items: [
          { name: 'Romatoid Artrit', nameEn: 'Rheumatoid Arthritis', severity: 'high' },
          { name: 'Lupus', nameEn: 'Lupus', severity: 'high' },
          { name: 'Çölyak Hastalığı', nameEn: 'Celiac Disease', severity: 'medium' },
          { name: 'Crohn Hastalığı', nameEn: 'Crohn\'s Disease', severity: 'high' },
          { name: 'Ülseratif Kolit', nameEn: 'Ulcerative Colitis', severity: 'high' },
          { name: 'Multipl Skleroz', nameEn: 'Multiple Sclerosis', severity: 'high' },
          { name: 'Psoriasis', nameEn: 'Psoriasis', severity: 'medium' }
        ]
      }
    }
  },
  MEDICATIONS: {
    name: 'Kullandığınız İlaçlar',
    nameEn: 'Current Medications',
    icon: '💊',
    color: 'green',
    subcategories: {
      PRESCRIPTION: {
        name: 'Reçeteli İlaçlar',
        nameEn: 'Prescription Medications',
        items: [
          { name: 'Kan Basıncı İlaçları', nameEn: 'Blood Pressure Medications', type: 'daily' },
          { name: 'Diyabet İlaçları', nameEn: 'Diabetes Medications', type: 'daily' },
          { name: 'Kalp İlaçları', nameEn: 'Heart Medications', type: 'daily' },
          { name: 'Antibiyotikler', nameEn: 'Antibiotics', type: 'temporary' },
          { name: 'Ağrı Kesiciler', nameEn: 'Pain Relievers', type: 'as_needed' },
          { name: 'Antidepresanlar', nameEn: 'Antidepressants', type: 'daily' },
          { name: 'Anksiyete İlaçları', nameEn: 'Anxiety Medications', type: 'as_needed' },
          { name: 'Astım İlaçları', nameEn: 'Asthma Medications', type: 'as_needed' },
          { name: 'Tiroid İlaçları', nameEn: 'Thyroid Medications', type: 'daily' },
          { name: 'Kolesterol İlaçları', nameEn: 'Cholesterol Medications', type: 'daily' }
        ]
      },
      OTC: {
        name: 'Reçetesiz İlaçlar',
        nameEn: 'Over-the-Counter Medications',
        items: [
          { name: 'Vitamin D', nameEn: 'Vitamin D', type: 'daily' },
          { name: 'Vitamin B12', nameEn: 'Vitamin B12', type: 'daily' },
          { name: 'Multivitamin', nameEn: 'Multivitamin', type: 'daily' },
          { name: 'Omega-3', nameEn: 'Omega-3', type: 'daily' },
          { name: 'Probiyotik', nameEn: 'Probiotics', type: 'daily' },
          { name: 'Kalsiyum', nameEn: 'Calcium', type: 'daily' },
          { name: 'Magnezyum', nameEn: 'Magnesium', type: 'daily' },
          { name: 'Demir', nameEn: 'Iron', type: 'daily' },
          { name: 'Parasetamol', nameEn: 'Acetaminophen', type: 'as_needed' },
          { name: 'İbuprofen', nameEn: 'Ibuprofen', type: 'as_needed' }
        ]
      },
      SUPPLEMENTS: {
        name: 'Takviye Edici Gıdalar',
        nameEn: 'Dietary Supplements',
        items: [
          { name: 'Protein Tozu', nameEn: 'Protein Powder', type: 'daily' },
          { name: 'Kreatin', nameEn: 'Creatine', type: 'daily' },
          { name: 'BCAA', nameEn: 'BCAA', type: 'exercise' },
          { name: 'Melatonin', nameEn: 'Melatonin', type: 'as_needed' },
          { name: 'Çinko', nameEn: 'Zinc', type: 'daily' },
          { name: 'Vitamin C', nameEn: 'Vitamin C', type: 'daily' },
          { name: 'Coenzyme Q10', nameEn: 'Coenzyme Q10', type: 'daily' },
          { name: 'Kurkumin', nameEn: 'Turmeric/Curcumin', type: 'daily' }
        ]
      }
    }
  }
};

export const SEVERITY_LEVELS = {
  low: { name: 'Hafif', nameEn: 'Mild', color: 'yellow', priority: 1 },
  medium: { name: 'Orta', nameEn: 'Moderate', color: 'orange', priority: 2 },
  high: { name: 'Şiddetli', nameEn: 'Severe', color: 'red', priority: 3 }
};

export const MEDICATION_TYPES = {
  daily: { name: 'Günlük', nameEn: 'Daily', color: 'blue' },
  as_needed: { name: 'Gerektiğinde', nameEn: 'As Needed', color: 'green' },
  temporary: { name: 'Geçici', nameEn: 'Temporary', color: 'purple' },
  exercise: { name: 'Egzersiz ile', nameEn: 'With Exercise', color: 'orange' }
};

export const getHealthItemsByCategory = (category, subcategory) => {
  return HEALTH_CATEGORIES[category]?.subcategories[subcategory]?.items || [];
};

export const searchHealthItems = (query, category = null) => {
  const results = [];
  const searchTerm = query.toLowerCase();
  
  const categoriesToSearch = category ? [category] : Object.keys(HEALTH_CATEGORIES);
  
  categoriesToSearch.forEach(catKey => {
    const cat = HEALTH_CATEGORIES[catKey];
    Object.entries(cat.subcategories).forEach(([subKey, subcat]) => {
      subcat.items.forEach(item => {
        if (item.name.toLowerCase().includes(searchTerm) || 
            item.nameEn.toLowerCase().includes(searchTerm)) {
          results.push({
            ...item,
            category: catKey,
            subcategory: subKey,
            categoryName: cat.name,
            subcategoryName: subcat.name
          });
        }
      });
    });
  });
  
  return results.slice(0, 10);
};

export const getHealthSummary = (userHealthData) => {
  const summary = {
    allergies: userHealthData.allergies?.length || 0,
    conditions: userHealthData.conditions?.length || 0,
    medications: userHealthData.medications?.length || 0,
    highSeverityItems: 0,
    dailyMedications: 0
  };
  
  // Count high severity items
  [...(userHealthData.allergies || []), ...(userHealthData.conditions || [])].forEach(item => {
    if (item.severity === 'high') {
      summary.highSeverityItems++;
    }
  });
  
  // Count daily medications
  (userHealthData.medications || []).forEach(med => {
    if (med.type === 'daily') {
      summary.dailyMedications++;
    }
  });
  
  return summary;
};
